<template>
        <div class="border -mb-px border-gray-200 bg-blue-50 rounded-b-lg">
            <div class="flex text-right">
                <div class="flex-1 text-sm px-2 py-1">Materials:</div>
                <div class="w-32 -ml-px text-sm px-2 py-1">{{ materialsTotal()/(item.quantity?item.quantity:1) | toCurrency }}</div>
                <div class="w-32 -ml-px text-sm px-2 py-1">{{ materialsTotal() | toCurrency }}</div>
                <div class="w-8"></div>
            </div>
            <div class="flex text-right">
                <div class="flex-1 text-sm px-2 py-1">Labour rates:</div>
                <div class="w-32 -ml-px text-sm px-2 py-1">{{ labourTotal()/(item.quantity?item.quantity:1)| toCurrency }}</div>
                <div class="w-32 -ml-px text-sm px-2 py-1">{{ labourTotal() | toCurrency }}</div>
                <div class="w-8"></div>
            </div>
            <div class="flex text-right">
                <div class="flex-1 text-sm font-semibold px-2 py-1">Total:</div>
                <div class="w-32 -ml-px text-sm px-2 font-semibold py-1">{{ total()/(item.quantity?item.quantity:1) | toCurrency }}</div>
                <div class="w-32 -ml-px text-sm px-2 font-semibold py-1">{{ total() | toCurrency }}</div>
                <div class="w-8"></div>
            </div>
        </div>

</template>

<script>
import EstimateTaskItemMaterialSearch from "./EstimateTaskItemMaterialSearch.vue";
import AutoresizableTextarea from "../../../ui/AutoresizableTextarea";
import {Estimate} from "@models";

export default {
    components: {AutoresizableTextarea, EstimateTaskItemMaterialSearch},
    props: {
        item: Object,
        estimate: Estimate,
    },
    data() {
        return {}
    },
    methods: {
        materialsTotal()
        {
            return this.item.materials.reduce((a, material) => a + material.total,0);
        },
        labourTotal()
        {
            return this.item.labour.reduce((a, labour) => a + labour.total,0);
        },
        total()
        {
            return this.materialsTotal()+this.labourTotal();
        },
    },
}
</script>
